import { http } from '@inertiajs/react'
import { axiosAdapter } from '@inertiajs/core'
import Axios from 'axios'
import { toast } from '../stores/toastStore'
import { t } from '../utils/I18n'
import { mountApplication } from '../utils/inertia/mountApplication'

// Inertia v3 ships its own XHR client. Point it at axios so the interceptors
// below (and @inertiaui/modal-react, which shares the client) stay in the
// request path.
http.setClient(axiosAdapter(Axios))

// Modal requests get a JSON error instead of a redirect, since redirects break
// the modal context. Surface it as a toast.
Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.config?.headers?.['X-InertiaUI-Modal']) {
      const message = error.response?.data?.error
      toast.error(message || t('shared.errors.generic'))
    }
    return Promise.reject(error)
  }
)

// Vite's import.meta.glob scanner does not support extglob negation; under
// Vite 8 it silently matches nothing. Use the array form with negative patterns.
const pages = import.meta.glob(
  [
    '../pages/**/[a-z]*.tsx',
    '!../pages/**/*.test.tsx',
    '!../pages/**/*.spec.tsx',
    '../contexts/**/pages/**/*.tsx',
    '!../contexts/**/pages/**/*.test.tsx',
    '!../contexts/**/pages/**/*.spec.tsx',
  ],
  { eager: true }
)

document.addEventListener('DOMContentLoaded', () => {
  void mountApplication({ pages })
})
